import { render } from "./movyapay-list-nova.vue?vue&type=template&id=07302301&scoped=true"
import script from "./movyapay-list-nova.vue?vue&type=script&lang=js"
export * from "./movyapay-list-nova.vue?vue&type=script&lang=js"

import "./movyapay-list-nova.vue?vue&type=style&index=0&id=07302301&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07302301"]])

export default __exports__